import { render, staticRenderFns } from "./WorkDetailTask.vue?vue&type=template&id=5cacc566&scoped=true"
import script from "./WorkDetailTask.vue?vue&type=script&lang=js"
export * from "./WorkDetailTask.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailTask.vue?vue&type=style&index=0&id=5cacc566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cacc566",
  null
  
)

export default component.exports